import { Link } from "react-router-dom";
import { Zap, Clock, ArrowRight } from "lucide-react";

// Promotional UPGRADE alert banner — shown inline on the dashboard (not a popup).
export default function UpgradePromoAlert() {
  return (
    <Link to="/app/billing" data-testid="upgrade-promo-alert"
      className="group flex items-center gap-4 rounded-2xl bg-slate-900 text-white px-5 py-4 relative overflow-hidden hover:shadow-lg hover:shadow-slate-300 transition">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="relative z-10 w-10 h-10 rounded-xl bg-sky-500 grid place-items-center shrink-0">
        <Zap className="w-5 h-5" fill="white" />
      </div>
      <div className="relative z-10 min-w-0 flex-1">
        <p className="font-display font-bold text-sm sm:text-base flex items-center gap-2">
          Upgrade sekarang <span className="hidden sm:inline-flex items-center gap-1 text-[11px] font-semibold bg-sky-500/20 text-sky-300 px-2 py-0.5 rounded-full"><Clock className="w-3 h-3" /> Harga early-access</span>
        </p>
        <p className="text-xs sm:text-sm text-slate-300 truncate">Harga bisa berubah sewaktu-waktu — kunci tarif terbaikmu & buka kredit + blast tanpa batas.</p>
      </div>
      <span className="relative z-10 inline-flex items-center gap-1.5 text-sm font-semibold bg-sky-500 hover:bg-sky-400 px-4 py-2 rounded-xl shrink-0 transition">
        Upgrade Now <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </Link>
  );
}
